export const MIN_CODE_LENGTH = 4;
export const MAX_CODE_LENGTH = 80;
export const MAX_DESCRIPTION_LENGTH = 255;
export const MAX_MAX_USES = 1_000_000;
export const MAX_MAX_USES_PER_USER = 1_000_000;
export const MAX_CENTS_DISCOUNT = 30_000; // $300.00
export const MAX_MIN_PURCHASE_CENTS = 100_000; // $1,000.00
export const MAX_PERCENTAGE_DISCOUNT = 100;

export const PROMO_CODE_TYPES = {
  CENTS: "cents",
  PERCENTAGE: "percentage",
};

export const PROMO_CODE_APPLIES_TO = {
  SUBTOTAL: "subtotal",
  TOTAL: "total",
};

export const MAX_PRODUCT_TAG_LENGTH = 50;

export const PROMO_CODE_MIN_ITEMS = ""; // Unlimited
